/*
 * Copyright (c) 2026. Tooling Team
 */

export const LAB_MVD_RETURN_STATE_KEY = "labMvdReturnState";

export const saveLabMvdReturnState = (returnState) => {
  if (!returnState) return;

  try {
    sessionStorage.setItem(
      LAB_MVD_RETURN_STATE_KEY,
      JSON.stringify(returnState)
    );
  } catch {
    // If storage is unavailable, route state still carries the same payload.
  }
};

export const readLabMvdReturnState = () => {
  try {
    const value = sessionStorage.getItem(LAB_MVD_RETURN_STATE_KEY);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

export const clearLabMvdReturnState = () => {
  try {
    sessionStorage.removeItem(LAB_MVD_RETURN_STATE_KEY);
  } catch {
    // Nothing to clear when storage is unavailable.
  }
};
